import { FieldDef, GroupDef, GuiDef, ValidatorDef, TabDefinition, CollapsableDef } from '@/objects/gui';
import { TrainingLane } from '@/objects/generated';
import { markRaw, computed } from 'vue';
import { DataSourceLookup, InputNullableInt, ValidatedInt } from '@/components';
import { useContestantStore } from '@/stores';
import { storeToRefs } from 'pinia';
import type { SelectLine, SelectLineValueType } from '@/objects/SelectLine';

export class TrainingLaneGuiDef extends GuiDef<TrainingLane> {
    constructor() {
        super('TrainingLane');

        const Contestant = storeToRefs(useContestantStore());
        const ContestantFirstnameWithEmptySource = computed(() => {
            return Contestant.ContestantFirstnameWithEmptyAsSelectLine.value;
        });
        const ContestantSurnameWithEmptySource = computed(() => {
            return Contestant.ContestantSurnameWithEmptyAsSelectLine.value;
        });
        const ContestantClubWithEmptySource = computed(() => {
            return Contestant.ContestantClubWithEmptyAsSelectLine.value;
        });
        const ContestantTeamWithEmptySource = computed(() => {
            return Contestant.ContestantTeamWithEmptyAsSelectLine.value;
        });
        const ContestantRegionWithEmptySource = computed(() => {
            return Contestant.ContestantRegionWithEmptyAsSelectLine.value;
        });
        const ContestantCategoryWithEmptySource = computed(() => {
            return Contestant.ContestantCategoryWithEmptyAsSelectLine.value;
        });

        const ContestantID = new FieldDef<TrainingLane>();
        ContestantID.Name = 'ContestantID';
        ContestantID.FieldName = 'ContestantID';
        ContestantID.DefinedFor = 'Both';
        ContestantID.TranslationKey = 'general.firstname';
        ContestantID.Editable = false;
        ContestantID.Filterable = false;
        ContestantID.Sortable = false;
        ContestantID.CssClasses = '';
        ContestantID.value = (traininglane) => traininglane.ContestantID;
        ContestantID.setValue = () => {};
        // @ts-expect-error @ts-ignore
        ContestantID.CellRenderer = markRaw(DataSourceLookup);
        ContestantID.CellRendererProps = { datasource: { mapsource: ContestantFirstnameWithEmptySource }, readonly: true, hideCaret: true };
        ContestantID.ExportValueFormatter = (obj: TrainingLane) => {
            return ContestantFirstnameWithEmptySource.value.get(obj.ContestantID)?.text;
        };
        ContestantID.Validator = null;
        ContestantID.SortDirection = undefined;
        ContestantID.cellClassRules = undefined;
        ContestantID.MinWidth = undefined;
        ContestantID.MaxWidth = undefined;
        ContestantID.Tooltip = null;
        this.Fields.push(ContestantID);

        const ContestantID1 = new FieldDef<TrainingLane>();
        ContestantID1.Name = 'ContestantID1';
        ContestantID1.FieldName = 'ContestantID';
        ContestantID1.DefinedFor = 'Both';
        ContestantID1.TranslationKey = 'general.surname';
        ContestantID1.Editable = false;
        ContestantID1.Filterable = false;
        ContestantID1.Sortable = false;
        ContestantID1.CssClasses = '';
        ContestantID1.value = (traininglane) => traininglane.ContestantID;
        ContestantID1.setValue = () => {};
        // @ts-expect-error @ts-ignore
        ContestantID1.CellRenderer = markRaw(DataSourceLookup);
        ContestantID1.CellRendererProps = { datasource: { mapsource: ContestantSurnameWithEmptySource }, readonly: true, hideCaret: true };
        ContestantID1.ExportValueFormatter = (obj: TrainingLane) => {
            return ContestantSurnameWithEmptySource.value.get(obj.ContestantID)?.text;
        };
        ContestantID1.Validator = null;
        ContestantID1.SortDirection = undefined;
        ContestantID1.cellClassRules = undefined;
        ContestantID1.MinWidth = undefined;
        ContestantID1.MaxWidth = undefined;
        ContestantID1.Tooltip = null;
        this.Fields.push(ContestantID1);

        const ContestantID2 = new FieldDef<TrainingLane>();
        ContestantID2.Name = 'ContestantID2';
        ContestantID2.FieldName = 'ContestantID';
        ContestantID2.DefinedFor = 'Both';
        ContestantID2.TranslationKey = 'general.club';
        ContestantID2.Editable = false;
        ContestantID2.Filterable = false;
        ContestantID2.Sortable = false;
        ContestantID2.CssClasses = '';
        ContestantID2.value = (traininglane) => traininglane.ContestantID;
        ContestantID2.setValue = () => {};
        // @ts-expect-error @ts-ignore
        ContestantID2.CellRenderer = markRaw(DataSourceLookup);
        ContestantID2.CellRendererProps = { datasource: { mapsource: ContestantClubWithEmptySource }, readonly: true, hideCaret: true };
        ContestantID2.ExportValueFormatter = (obj: TrainingLane) => {
            return ContestantClubWithEmptySource.value.get(obj.ContestantID)?.text;
        };
        ContestantID2.Validator = null;
        ContestantID2.SortDirection = undefined;
        ContestantID2.cellClassRules = undefined;
        ContestantID2.MinWidth = undefined;
        ContestantID2.MaxWidth = undefined;
        ContestantID2.Tooltip = null;
        this.Fields.push(ContestantID2);

        const ContestantID3 = new FieldDef<TrainingLane>();
        ContestantID3.Name = 'ContestantID3';
        ContestantID3.FieldName = 'ContestantID';
        ContestantID3.DefinedFor = 'Both';
        ContestantID3.TranslationKey = 'general.team';
        ContestantID3.Editable = false;
        ContestantID3.Filterable = false;
        ContestantID3.Sortable = false;
        ContestantID3.CssClasses = '';
        ContestantID3.value = (traininglane) => traininglane.ContestantID;
        ContestantID3.setValue = () => {};
        // @ts-expect-error @ts-ignore
        ContestantID3.CellRenderer = markRaw(DataSourceLookup);
        ContestantID3.CellRendererProps = { datasource: { mapsource: ContestantTeamWithEmptySource }, readonly: true, hideCaret: true };
        ContestantID3.ExportValueFormatter = (obj: TrainingLane) => {
            return ContestantTeamWithEmptySource.value.get(obj.ContestantID)?.text;
        };
        ContestantID3.Validator = null;
        ContestantID3.SortDirection = undefined;
        ContestantID3.cellClassRules = undefined;
        ContestantID3.MinWidth = undefined;
        ContestantID3.MaxWidth = undefined;
        ContestantID3.Tooltip = null;
        this.Fields.push(ContestantID3);

        const ContestantID4 = new FieldDef<TrainingLane>();
        ContestantID4.Name = 'ContestantID4';
        ContestantID4.FieldName = 'ContestantID';
        ContestantID4.DefinedFor = 'Both';
        ContestantID4.TranslationKey = 'general.region';
        ContestantID4.Editable = false;
        ContestantID4.Filterable = false;
        ContestantID4.Sortable = false;
        ContestantID4.CssClasses = '';
        ContestantID4.value = (traininglane) => traininglane.ContestantID;
        ContestantID4.setValue = () => {};
        // @ts-expect-error @ts-ignore
        ContestantID4.CellRenderer = markRaw(DataSourceLookup);
        ContestantID4.CellRendererProps = { datasource: { mapsource: ContestantRegionWithEmptySource }, readonly: true, hideCaret: true };
        ContestantID4.ExportValueFormatter = (obj: TrainingLane) => {
            return ContestantRegionWithEmptySource.value.get(obj.ContestantID)?.text;
        };
        ContestantID4.Validator = null;
        ContestantID4.SortDirection = undefined;
        ContestantID4.cellClassRules = undefined;
        ContestantID4.MinWidth = undefined;
        ContestantID4.MaxWidth = undefined;
        ContestantID4.Tooltip = null;
        this.Fields.push(ContestantID4);

        const ContestantID5 = new FieldDef<TrainingLane>();
        ContestantID5.Name = 'ContestantID5';
        ContestantID5.FieldName = 'ContestantID';
        ContestantID5.DefinedFor = 'Both';
        ContestantID5.TranslationKey = 'category.category';
        ContestantID5.Editable = false;
        ContestantID5.Filterable = false;
        ContestantID5.Sortable = false;
        ContestantID5.CssClasses = '';
        ContestantID5.value = (traininglane) => traininglane.ContestantID;
        ContestantID5.setValue = () => {};
        // @ts-expect-error @ts-ignore
        ContestantID5.CellRenderer = markRaw(DataSourceLookup);
        ContestantID5.CellRendererProps = { datasource: { mapsource: ContestantCategoryWithEmptySource }, readonly: true, hideCaret: true };
        ContestantID5.ExportValueFormatter = (obj: TrainingLane) => {
            return ContestantCategoryWithEmptySource.value.get(obj.ContestantID)?.text;
        };
        ContestantID5.Validator = null;
        ContestantID5.SortDirection = undefined;
        ContestantID5.cellClassRules = undefined;
        ContestantID5.MinWidth = undefined;
        ContestantID5.MaxWidth = undefined;
        ContestantID5.Tooltip = null;
        this.Fields.push(ContestantID5);

        const Lane = new FieldDef<TrainingLane>();
        Lane.Name = 'Lane';
        Lane.FieldName = 'Lane';
        Lane.DefinedFor = 'Both';
        Lane.TranslationKey = 'traininglane.lane';
        Lane.Editable = true;
        Lane.Filterable = false;
        Lane.Sortable = false;
        Lane.CssClasses = '';
        Lane.value = (traininglane) => traininglane.Lane;
        Lane.setValue = (traininglane, value) => {
            if (value === undefined || value === '' || isNaN(value)) {
                value = null;
            }
            traininglane.Lane = value;
        };
        Lane.DetailEditor = markRaw(InputNullableInt);
        Lane.DetailEditorProps = {};
        Lane.CellEditor = markRaw(InputNullableInt);
        Lane.CellEditorProps = {};
        Lane.CellRenderer = markRaw(ValidatedInt);
        Lane.CellRendererProps = {};
        Lane.Validator = null;
        Lane.SortDirection = undefined;
        Lane.cellClassRules = undefined;
        Lane.MinWidth = undefined;
        Lane.MaxWidth = undefined;
        Lane.Tooltip = null;
        this.Fields.push(Lane);
    }

    public async LoadDependencies() {
        await useContestantStore().EnsureLoaded(['Contestants']);
    }
}
